// Filtro de importe por RANGO (de X a Y M€) con ayuda contextual clara.
// Reutilizado en Mercado/Oportunidades y Ofertas/Licitaciones para que el
// usuario sepa exactamente qué mide el importe (total de licitación, no anual).
import React from "react";
import { X } from "lucide-react";
import { HelpTip } from "@/components/HelpTip";

// Texto único compartido: responde a la duda "¿es el importe completo de la
// licitación o el anual?" de forma inequívoca.
export const IMPORTE_BASE_HELP =
  "Importe = presupuesto TOTAL de la licitación (el importe completo del contrato que se licita), " +
  "en millones de € (M€). Donde Valoriza concurre en UTE, se aplica su porcentaje de participación. " +
  "NO es el importe anual (hoy no hay dato de importe anual cargado). " +
  "Usa «mín» para ver desde ese importe, «máx» para ver hasta ese importe, o ambos para un rango.";

export function ImporteRangeFilter({
  min = 0,
  max = 0,
  onChange,
  baseText = IMPORTE_BASE_HELP,
  testidPrefix = "importe-filter",
  className = "",
}) {
  const nMin = Number(min) || 0;
  const nMax = Number(max) || 0;
  const active = nMin > 0 || nMax > 0;
  const set = (a, b) => onChange(Math.max(0, Number(a) || 0), Math.max(0, Number(b) || 0));

  return (
    <div
      data-testid={`${testidPrefix}-wrap`}
      className={`inline-flex items-center gap-1 border rounded-lg px-2 py-1 text-[11px] ${
        active ? "border-sky-300 bg-sky-50" : "border-gray-200 bg-white"
      } ${className}`}
    >
      <span className={active ? "font-semibold text-sky-700" : "text-gray-500"}>Importe</span>
      <HelpTip text={baseText} />
      <input
        type="number"
        min={0}
        inputMode="decimal"
        placeholder="mín"
        value={nMin > 0 ? nMin : ""}
        onChange={(e) => set(e.target.value, nMax)}
        data-testid={`${testidPrefix}-min`}
        className="w-12 border border-gray-200 rounded px-1 py-0.5 text-right bg-white outline-none focus:border-sky-400"
        title="Importe mínimo (M€)"
      />
      <span className="text-gray-400">–</span>
      <input
        type="number"
        min={0}
        inputMode="decimal"
        placeholder="máx"
        value={nMax > 0 ? nMax : ""}
        onChange={(e) => set(nMin, e.target.value)}
        data-testid={`${testidPrefix}-max`}
        className="w-12 border border-gray-200 rounded px-1 py-0.5 text-right bg-white outline-none focus:border-sky-400"
        title="Importe máximo (M€)"
      />
      <span className={`font-mono ${active ? "text-sky-700 font-bold" : "text-gray-500"}`}>M€</span>
      {active && (
        <button
          type="button"
          onClick={() => set(0, 0)}
          data-testid={`${testidPrefix}-reset`}
          title="Quitar filtro de importe"
          className="text-sky-700 hover:text-sky-900"
        >
          <X size={11} />
        </button>
      )}
    </div>
  );
}

export default ImporteRangeFilter;
